import { render } from "./Profile.vue?vue&type=template&id=cfd4d1d8"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"

import "./Profile.vue?vue&type=style&index=0&id=cfd4d1d8&lang=scss"
script.render = render

export default script